<template>
  <section class="m-5">
    <div class="row">
      <div class="col mt-3">
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-skeleton-table
              :rows="5"
              :columns="3"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table>
          </template>
          <b-table
            :items="getAttributes"
            :fields="fields"
            :total-rows="getTotalItems"
            :per-page="perPage"
            class="mt-5"
          >
            <template #cell(actions)="{item,index}">
              <b-row>
                <b-col>
                  <b-button
                    variant="primary"
                    :to="{ name: 'EditAttribute', params: { id: item.id } }"
                    >Modifier
                  </b-button></b-col
                >&nbsp;
                <b-col class="pb-2">
                  <b-button
                    variant="danger"
                    @click="deleteAttribute(item, index)"
                    >Supprimer</b-button
                  ></b-col
                >
              </b-row>
            </template>
            <template #cell(categoriesMirakls)="row">
              <b-badge
                class="m-2"
                variant="secondary"
                v-for="item in row.item.categoriesMirakls"
                :key="item.id"
                >{{ item.hierarchyLabel }}</b-badge
              >
            </template>
          </b-table>
          <div class="mt-3">
            <b-pagination
              v-model="currentPage"
              :total-rows="getTotalItems"
              :per-page="perPage"
              align="center"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </b-skeleton-wrapper>
      </div>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers, mapGetters as mapGettersIndex } from "vuex";
const { mapGetters } = createNamespacedHelpers("attributes");
export default {
  name: "ListAttributes",
  data() {
    return {
      currentPage: 1,
      perPage: 30,
      fields: [
        {
          key: "categoriesMirakls"
        },
        {
          key: "label",
          thClass: "sizeTd"
        },
        {
          key: "actions",
          class: "table-action"
        }
      ],
      attributeQuery: ""
    };
  },
  methods: {
    message(item) {
      const h = this.$createElement;
      const messageVNode = h("div", { class: ["foobar"] }, [
        h("p", { class: ["text-center"] }, [
          " Etes-vous sûr de vouloir supprimer l'attribut ",
          h("strong", item.label)
        ])
      ]);
      return messageVNode;
    },
    deleteAttribute(item, index) {
      this.$bvModal
        .msgBoxConfirm([this.message(item)], {
          title: "Suppression d'attribut",
          centered: true,
          okVariant: "danger",
          okTitle: "OUI",
          cancelTitle: "NON",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(bool => {
          if (bool) {
            this.$store.dispatch("attributes/deleteAttribut", {
              id: item.id,
              index
            });
          }
        });
    }
  },
  computed: {
    ...mapGettersIndex(["isLoading"]),
    ...mapGetters(["getAttributes", "getTotalItems"]),
    rows() {
      return this.getTotalItems;
    }
  },
  watch: {
    currentPage(page) {
      this.$store.dispatch("attributes/getList", { page });
    }
  },
  created() {
    this.$store.dispatch("attributes/getList", { page: this.currentPage });
  }
};
</script>

<style>
.sizeTd {
  width: 200px;
  text-align: center;
}
.table-action {
  width: 241px;
}
</style>
